import type { Identity } from '@wix/editor-elements-types/utils';
import type { IMenuToggleProps } from '../MenuToggle.types';
import inlinePopupToggleSkin1 from './skinComps/inlinePopupToggleSkin1';
import inlinePopupToggleSkin2 from './skinComps/inlinePopupToggleSkin2';
import inlinePopupToggleSkin3 from './skinComps/inlinePopupToggleSkin3';
import inlinePopupToggleSkin4 from './skinComps/inlinePopupToggleSkin4';
import inlinePopupToggleSkin5 from './skinComps/inlinePopupToggleSkin5';
import inlinePopupToggleSkin6 from './skinComps/inlinePopupToggleSkin6';
import inlinePopupToggleSkin7 from './skinComps/inlinePopupToggleSkin7';
import inlinePopupToggleSkin8 from './skinComps/inlinePopupToggleSkin8';
import inlinePopupToggleSkin9 from './skinComps/inlinePopupToggleSkin9';
import inlinePopupToggleSkin10 from './skinComps/inlinePopupToggleSkin10';
import inlinePopupToggleSkin11 from './skinComps/inlinePopupToggleSkin11';
import inlinePopupToggleSkin12 from './skinComps/inlinePopupToggleSkin12';
import inlinePopupToggleSkin13 from './skinComps/inlinePopupToggleSkin13';
import inlinePopupToggleSkin14 from './skinComps/inlinePopupToggleSkin14';
import inlinePopupToggleSkin15 from './skinComps/inlinePopupToggleSkin15';
import inlinePopupToggleSkin16 from './skinComps/inlinePopupToggleSkin16';

export const SKIN_NAMES: Identity<IMenuToggleProps['skin']> = {
  inlinePopupToggleSkin1: 'inlinePopupToggleSkin1',
  inlinePopupToggleSkin2: 'inlinePopupToggleSkin2',
  inlinePopupToggleSkin3: 'inlinePopupToggleSkin3',
  inlinePopupToggleSkin4: 'inlinePopupToggleSkin4',
  inlinePopupToggleSkin5: 'inlinePopupToggleSkin5',
  inlinePopupToggleSkin6: 'inlinePopupToggleSkin6',
  inlinePopupToggleSkin7: 'inlinePopupToggleSkin7',
  inlinePopupToggleSkin8: 'inlinePopupToggleSkin8',
  inlinePopupToggleSkin9: 'inlinePopupToggleSkin9',
  inlinePopupToggleSkin10: 'inlinePopupToggleSkin10',
  inlinePopupToggleSkin11: 'inlinePopupToggleSkin11',
  inlinePopupToggleSkin12: 'inlinePopupToggleSkin12',
  inlinePopupToggleSkin13: 'inlinePopupToggleSkin13',
  inlinePopupToggleSkin14: 'inlinePopupToggleSkin14',
  inlinePopupToggleSkin15: 'inlinePopupToggleSkin15',
  inlinePopupToggleSkin16: 'inlinePopupToggleSkin16',
};

export const MenuToggleSkinMap = {
  inlinePopupToggleSkin1,
  inlinePopupToggleSkin2,
  inlinePopupToggleSkin3,
  inlinePopupToggleSkin4,
  inlinePopupToggleSkin5,
  inlinePopupToggleSkin6,
  inlinePopupToggleSkin7,
  inlinePopupToggleSkin8,
  inlinePopupToggleSkin9,
  inlinePopupToggleSkin10,
  inlinePopupToggleSkin11,
  inlinePopupToggleSkin12,
  inlinePopupToggleSkin13,
  inlinePopupToggleSkin14,
  inlinePopupToggleSkin15,
  inlinePopupToggleSkin16,
};
